// extracted by mini-css-extract-plugin
export default {"navbar":"nav_navbar__WLwo3","logo":"nav_logo__sOWCY"};